// project-imports
import { getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - CONNECT REQUEST ||============================== //

export async function handleConnectRequest(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest(`/connect-requests?agent-id=${encodeURIComponent(action.data.agentId)}`);
    case 'create':
      return postRequest('/connect-requests', action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleConnectRequest] - Unknown method');
      break;
  }
}
